/* Rejillas de catálogo: filas iguales en toda la lista, sin tareas por scroll.
   Los carruseles ya comparten sus filas mediante subgrid y no se modifican. */
(function () {
  'use strict';
  if (window.__miCardAlignment) return;
  var stats = window.__miCardAlignment = { passes: 0 };
  var groupSelector = '.l4cl, .mi-seleccion__productos';
  var rows = [
    ['title', '.framer-17ex6ke'], ['rating', '.framer-nmyrpr'],
    ['price', '.mi-card__precios'], ['addi', '.mi-card__addi'],
    ['presentation', '.mi-card__presentacion'], ['sizes', '[data-mi-tallas]'],
    ['cta', '[data-mi-cta]']
  ];
  var groups = new Map(), pending = new Set(), frame = null;

  function cards(group) {
    return Array.from(group.querySelectorAll('[data-mi-tarjeta]')).filter(function (card) {
      return card.closest(groupSelector) === group;
    });
  }
  function schedule(group) {
    if (group) pending.add(group);
    if (frame !== null || document.hidden) return;
    frame = window.requestAnimationFrame(flush);
  }
  function refreshAll() {
    groups.forEach(function (_, group) { pending.add(group); });
    schedule();
  }
  function flush() {
    frame = null;
    if (document.hidden) return;
    var measurements = [];
    pending.forEach(function (group) {
      if (!group.isConnected || !group.getBoundingClientRect().width) return;
      var maxima = rows.map(function () { return 0; });
      cards(group).forEach(function (card) {
        rows.forEach(function (row, i) {
          var section = card.querySelector(row[1]);
          if (section) maxima[i] = Math.max(maxima[i], section.getBoundingClientRect().height);
        });
      });
      measurements.push([group, maxima]);
    });
    pending.clear();
    // Todas las lecturas terminan antes de escribir; sólo se actualizan valores diferentes.
    measurements.forEach(function (measurement) {
      rows.forEach(function (row, i) {
        var name = '--mi-card-' + row[0], value = Math.ceil(measurement[1][i]) + 'px';
        if (measurement[0].style.getPropertyValue(name) !== value) measurement[0].style.setProperty(name, value);
      });
    });
    if (measurements.length) stats.passes++;
  }
  var widths = typeof ResizeObserver === 'function' ? new ResizeObserver(function (entries) {
    entries.forEach(function (entry) {
      var state = groups.get(entry.target);
      if (!state || Math.abs(state.width - entry.contentRect.width) < .5) return;
      state.width = entry.contentRect.width;
      schedule(entry.target);
    });
  }) : null;
  function discover() {
    groups.forEach(function (state, group) {
      if (group.isConnected) return;
      state.observer.disconnect();
      if (widths) widths.unobserve(group);
      groups.delete(group);
      pending.delete(group);
    });
    document.querySelectorAll(groupSelector).forEach(function (group) {
      if (groups.has(group) || !cards(group).length) return;
      group.setAttribute('data-mi-card-group', '');
      var observer = new MutationObserver(function (records) {
        if (records.some(function (record) { return record.type !== 'attributes' || record.target === group; })) schedule(group);
      });
      // Estilos propios no se observan; las clases internas de los controles tampoco recalculan.
      observer.observe(group, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class'] });
      groups.set(group, { width: -1, observer: observer });
      if (widths) widths.observe(group);
      schedule(group);
    });
  }
  function init() {
    discover();
    var content = document.getElementById('content');
    if (content) new MutationObserver(function (records) {
      var changed = records.some(function (record) {
        return Array.from(record.addedNodes).concat(Array.from(record.removedNodes)).some(function (node) {
          return node.nodeType === 1 && (node.matches(groupSelector) || node.querySelector(groupSelector));
        });
      });
      if (changed) discover();
    }).observe(content, { childList: true, subtree: true });
    if (!widths) {
      var previousWidth = document.documentElement.clientWidth;
      window.addEventListener('resize', function () {
        var width = document.documentElement.clientWidth;
        if (width === previousWidth) return;
        previousWidth = width;
        refreshAll();
      }, { passive: true });
    }
    if (document.fonts) {
      document.fonts.ready.then(refreshAll);
      document.fonts.addEventListener('loadingdone', refreshAll);
    }
    document.addEventListener('visibilitychange', function () { if (!document.hidden) schedule(); });
    document.addEventListener('shopify:section:load', discover);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
